export const operationColors = {
  summary: '#2196f3',
  'short-form': '#ffb300',
  expand: '#8e24aa',
  sentiment: '#e91e63',
  classify: '#43a047',
  describe: '#0288d1',
  tag: '#fb8c00',
  'generate-image': '#0288d1',
  'load-image': '#0288d1',
  'load-file': '#ffb300',
  'create-prompt': '#8e24aa',
  'submit-prompt': '#8e24aa',
  'new-text-node': '#2196f3',
  'new-image-node': '#fb8c00',
  'google-sheets': '#ffb300',
  'create-map': '#8e24aa',
};

export const getOperationColor = (operation) =>
  operationColors[operation] || '#999';
